import axios from "axios"

export interface AccountDetailsData {
  firstName: string
  lastName: string
  displayName: string
  email: string
}

export interface UpdateAccountDetailsInput extends AccountDetailsData {
  currentPassword: string
  newPassword: string
  confirmNewPassword: string
}

export interface AccountDetailsResponse {
  ok: boolean
  code?: string
  message?: string
  details?: AccountDetailsData
  errors?: string[]
}

export const getAccountDetails = async (): Promise<AccountDetailsResponse> => {
  const { data } = await axios.get<AccountDetailsResponse>(
    "/api/account/details"
  )

  return data
}

export const updateAccountDetails = async (
  payload: UpdateAccountDetailsInput
): Promise<AccountDetailsResponse> => {
  const { data } = await axios.post<AccountDetailsResponse>(
    "/api/account/details",
    payload
  )

  return data
}
